import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from "../../assets/styles/appointments.module.css"
import { FormGroup, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { SearchIcon } from '../../utils/functions/Icons';
import { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import { RootState } from '../../utils/store';
import Loader from '../common/Loader';
import NoDataFound from '../common/NoDataFound';
import { getHealthCheckupsApi} from '../../utils/api/services';
export default function ReportReceived() {
    const [searchValue, setSearchValue] = useState('')
    const [year, setYear] = useState<string | number>("0");
    const [loading, setLoading] = useState(false)
    const [labTestData, setLabTestData] = useState<PreEmpLabTest[] | []>([])
    const { LoginData } = useSelector((state: RootState) => state.auth)

    const handleViewReport = (e: React.MouseEvent<HTMLButtonElement>, item: string) => {
        e.stopPropagation();
        window.open(item)
    }
    const fetchLabtestApi = async (data: { search: string; status: string; filter: string | number, companyId: number }) => {
        try {
            setLoading(true);
            const result = await getHealthCheckupsApi(data);
            if (result?.success) {
                setLabTestData(result?.labTests);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (LoginData) {
            if (searchValue) {
                const cleanFunction = setTimeout(() => {
                    fetchLabtestApi({ search: searchValue, status: '6', filter: year, companyId: LoginData?.companyId });
                }, 1000);
                return () => clearTimeout(cleanFunction);
            } else {
                fetchLabtestApi({ search: searchValue, status: '6', filter: year, companyId: LoginData?.companyId });
            }
        }
    }, [searchValue, year]);


    return (
        <div>
            <div className={'mb-6 flex justify-between items-center flex-col md:flex-row w-full max-w-full gap-y-4 md:gap-y-0'}>
                <FormGroup className="customFormGroup md:w-1/2 w-full">
                    <TextField
                        className={`custumTextField ${styles.InputStyle}`}
                        id="searchValue"
                        name="searchValue"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        placeholder='search'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormGroup>
                <FormGroup className="customFormGroup md:w-36 w-full">
                    <Select
                        className={`custumTextField profileInput`}
                        placeholder="Date"
                        defaultValue={"0"}
                        value={year}
                        onChange={(e) => setYear(e.target?.value)}
                    >
                        <MenuItem selected value="0">All</MenuItem>
                        <MenuItem value="1">Last Month</MenuItem>
                        <MenuItem value="2">6 Months</MenuItem>
                        <MenuItem value="3">1 Year</MenuItem>
                    </Select>
                </FormGroup>
            </div>
            {
                loading ? <Loader />
                    :
                    <TableContainer component={Paper} className='TableContainer'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className='custumTableHead'>
                                <TableRow className={styles.completeTableRow}>
                                    <TableCell>Patient Name</TableCell>
                                    <TableCell align="right">Gender</TableCell>
                                    <TableCell align="right">Phone</TableCell>
                                    <TableCell align="right">Date Of Birth</TableCell>
                                    <TableCell align="right">Check Up Date</TableCell>
                                    <TableCell align="right">Status</TableCell>
                                    <TableCell align="right">Type</TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                labTestData?.length > 0 ?
                                    <TableBody>
                                        {
                                            labTestData?.map((item, index) => {
                                                const bgColor = item?.status === "Scheduled" ? "#80B628" : item?.status === "Completed" ? "#54a276" : item?.status === "Pending" ? "#ffcd29" : item?.status === "Cancelled" ? "#aa2626" : "#54a276"
                                                const typeColor = item?.type === "pre-enroll" ? "#0562cc" : "#6fc9c6"
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        className='custumTableRow'
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                  <TableCell component="th" scope="row">
                                                            {item?.name}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.gender}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.phone}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.dateofbirth}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.health_check_up_date}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <div className='flex items-center justify-center'>
                                                                <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{ borderColor: bgColor, color: bgColor }} >{item?.status}</button>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{ borderColor: typeColor, color: typeColor }} >{item?.type}</button>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <button className={`outLineBtn w-full ${styles.downloadPresBtn}`} onClick={(e) => item?.report_url && handleViewReport(e, item?.report_url)}>View Report</button>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow
                                            className='custumTableRow'
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row" colSpan={8}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                            }
                        </Table>
                    </TableContainer>
            }
        </div>
    );
}